export const KPI_PRICING = {
    ACTUAL: 'actualPrice',
    LIST: 'listPrice',
    TOTAL: 'totalPrice'
}

export const KPI_TYPE = {
    ACTUAL_PRICE: 'actual_price',
    LIST_PRICE: 'list_price',
    DISCOUNT_RRSP: 'diff',
    DISCOUNT_LIST_PRICE: 'discount_lp'
}

export const GROUPED_BY = {
    GENERAL: 'General',
    COUNTRY: 'country',
    RETAILER: 'id_site',
    CATEGORY: 'id_category',
    BRAND: 'id_brand',
    COMPANY: 'id_company',
    SKU: 'id_sku',
    SELLER: 'id_seller',
    VIDEO_CONTENT: 'video',
    USER_MANUAL: 'manual',
    STOCK: 'stock',
    MARKETPLACE: 'marketplace',
    PAGE_CATEGORY: 'source_page_category',
    PAGE_PRODUCT_TYPE: 'source_page_product_type',
    IMAGE_TYPE: 'resource_type',
    SECTION_CATEGORY: 'id_section_category',
    KEYWORD_CATEGORY: 'id_keyword_category',
    TAG: 'id_tag'
}

export const VALIDATED = {
    VALIDATED: 1,
    NON_VALIDATED: 0
}

export const NORMALIZED = {
    NORMALIZED: 1,
    NOT_NORMALIZED: 0
}